module.exports = __webpack_public_path__ + "static/media/passport.7611af4f.png";